
const common = {
	 openId:'',
   access_token:'',
   unionId:'',
   userId:''
}
export default common


// WEBPACK FOOTER //
// ./src/util/common.js